import { HELPER_DOWNLOAD_PATH } from '@skyrover/shared/constants';

/** Resolved URL for the Skyrover Helper Windows installer download link. */
export function getHelperDownloadUrl(): string {
  const override = import.meta.env.VITE_HELPER_DOWNLOAD_URL?.trim();
  if (override) {
    return override;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${HELPER_DOWNLOAD_PATH}`;
  }

  return HELPER_DOWNLOAD_PATH;
}
